import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import Button from '../../Button'
import { ModalResizeButton } from '../../Modal'
import { useEmailDraft } from '../Email.hooks'
import { EmailCreationFormActions } from '../EmailCreationFormActions'

import * as styles from './EmailReplyFormActions.module.css'

import DeleteIcon from '../../../icons/delete.svg'

function EmailReplyFormActions({
  MakeFormFullScreenButton = ModalResizeButton,
  isMobileActions,
  onMakeFormFullScreen,
  onRemoveDraft,
  ...restProps
}) {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  const { draft: emailDraft } = useEmailDraft()

  function handleClickMakeFormFullScreen() {
    onMakeFormFullScreen(values)
  }

  return (
    <EmailCreationFormActions {...restProps} isMobileActions={isMobileActions}>
      {!isMobileActions ? (
        <div className={styles.buttons}>
          {emailDraft ? (
            <Button.Icon
              isGrey
              Icon={DeleteIcon}
              tooltip={t('Email.ReplyFormRemoveDraftButtonTooltipKey')}
              onClick={onRemoveDraft}
            />
          ) : null}
          {MakeFormFullScreenButton ? (
            <MakeFormFullScreenButton onClick={handleClickMakeFormFullScreen} />
          ) : null}
        </div>
      ) : null}
    </EmailCreationFormActions>
  )
}

export default EmailReplyFormActions
